import React, { useState } from 'react';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const ListItemValues = [
    { value: 0, label: "Show All" },
    { value: 10, label: "Top 10" },
    { value: 20, label: "Top 20" },
    { value: 35, label: "Top 35" },
    { value: 50, label: "Top 50" }
]
const AppFilter = ({ onFilterSave, onFilterClear }) => {

    const [SelectedList, setSelectedList] = useState({ value: 10, label: "Top 10" });
    const [CheckedListItem, setCheckedListItem] = useState(-1);
    const [ShowFilter, setShowFilter] = useState(false);

    const OnListItemChange = (listData) => {
        let listValue = listData ? listData : null;
        if (listValue !== null) {
            setSelectedList(listValue);
        }
        else {
            setSelectedList({ value: 10, label: "Top 10" });
        }

    };

    onFilterClear = () => {
        setSelectedList({ value: 10, label: "Top 10" });
        setCheckedListItem(-1);
    };

    const ApplyFilter = () => {
        let FilterData = {
            item: SelectedList.value,
            checkedItem: CheckedListItem
        }

        setShowFilter(!ShowFilter);
        onFilterSave(FilterData);
    };

    const onCheckChange = (e) => {
        if (e.target.name === "asc" && e.target.checked) {
            setCheckedListItem(1);
        }
        else if (e.target.name === "desc" && e.target.checked) {
            setCheckedListItem(-1);
        }
        else {
            setCheckedListItem(-1);
        }

    };

    const OnFilterShow = () => {
        setShowFilter(!ShowFilter);
    }

    return (
        <div>
            <div style={{ position: "relative" }}>
                <div>
                    <span style={{ verticalAlign: "middle" }} onClick={OnFilterShow}><FontAwesomeIcon icon={faFilter} /></span>
                </div>
                {ShowFilter && (<div className="FilterpageStyle">
                    <table className="table">
                        <tbody>
                            <tr>
                                <td style={{ width: "100px" }}>Items</td>
                                <td>
                                    <div>
                                        <Select value={SelectedList} isClearable={true} isSearchable={true} placeholder="Select"
                                            options={ListItemValues}
                                            onChange={OnListItemChange}></Select>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "100px" }}>Ascending</td>
                                <td>
                                    <div>
                                        <input name="asc" checked={CheckedListItem === 1} onChange={onCheckChange} type="checkbox"></input>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "100px" }}>Descending</td>
                                <td>
                                    <div>
                                        <input name="desc" checked={CheckedListItem === -1} onChange={onCheckChange} type="checkbox"></input>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-right">
                                <td colSpan="2">
                                    <span className="btnStyleWithoutFill" onClick={OnFilterShow} style={{ marginRight: "10px" }}>Close</span>
                                    <span className="btnStyleWithoutFill" onClick={onFilterClear} style={{ marginRight: "10px" }}>Clear</span>
                                    <span className="btnStyleWithoutFill" onClick={ApplyFilter}>Apply</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>)}
            </div>
        </div>
    );
};

export default AppFilter;